import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormRoute: InvariantJiraRoute = {
	name: 'software-form',
	path: '/jira/software/projects/:projectKey/form',
	exact: true,
};
